import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import CompanyCustomerCases from '@/types/table/companyCustomerCases';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface CompanyCustomerCasesData extends CompanyCustomerCases {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class CompanyCustomerCasesController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<CompanyCustomerCasesData>>(API_CONTEXT + '/app/companyCustomerCases/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<CompanyCustomerCasesData>(API_CONTEXT + '/app/companyCustomerCases/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/companyCustomerCases/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/companyCustomerCases/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/companyCustomerCases/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/companyCustomerCases/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/companyCustomerCases/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/companyCustomerCases/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/companyCustomerCases/deleteBatch', params, httpOptions);
  }
}
